export class CompanyInvite {
  uid!: string;
  email!: string;
  inviteCode!: string;
  currentCompanyId!: string;
  expirationDate!: Date | string;
  redeemedBy?: string;
  /** uid of the admin who issued (or last re-sent) the invite (#874). */
  createdBy?: string;
  createdAt!: string;
  updatedAt!: string;
  invalidated: boolean = false;
  unsubscribed: boolean = false;

  constructor(data: object | any) {
    Object.assign(this, data);
    if (data.uid) {
      this.inviteCode = data.uid;
    }
  }
}
